<template>
  <div :class="{hidden: !is_open}" class="debug">
    <a href="javascript:void(0)" style="display:inline-block;float:right" @click="is_open=!is_open">●●●</a>
    <div v-if="is_open" class="content">
      <slot/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.debug {
  position:fixed;
  width:100%;
  bottom:0;
  left:0;
  padding:10px;
  background:rgba(0, 0, 0, 0.5);
  color:#fff;
  z-index:99999;
  &.hidden {
    height:20px;
    line-height:20px;
    padding:0;
    text-align:center;
    width:30px;
    left:auto;
    right:0;
    border-radius:4px;
    text-align:center;
    .content {
      display:none;
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      is_open: true
    }
  }
}
</script>
